import React from "react";

function FieldError({ error }) {
  if (!error) return null;
  return <span className="required">{error}</span>;
}

export default FieldError;